import { useContext, useState, useEffect } from "react";
import { O as OffersContext, u as useFetchOffers, G as GlobalHeadContext, c as useCookies } from "./OffersContext-CKQZ2fOu.js";
import { s as SOURCE_KEY, t as COOKIE_EXPIRATION_TIME } from "./index-Dm8TmbQW.js";
import { g as getEnvVariable } from "./index-DF2r5-bd.js";
const useOffersContext = () => {
  const context = useContext(OffersContext);
  if (!context) {
    return {
      onClickHandler: void 0,
      // Default no-op function
      useOffersHook: ({ environment }) => useFetchOffers({ environment })
      // Default API handler
    };
  }
  return context;
};
const useSourceIdCookie = () => {
  const { environment: currentEnv } = useContext(GlobalHeadContext);
  const [{ sourceid }, setCookie] = useCookies([`${SOURCE_KEY}`]);
  const [location, setLocation] = useState(null);
  useEffect(() => {
    const { search = null } = (window == null ? void 0 : window.location) ?? {};
    setLocation(window == null ? void 0 : window.location);
    if (!search) return;
    const sourceIdParam = new URLSearchParams(search).get(`${SOURCE_KEY}`);
    if (sourceIdParam) {
      setCookie(`${SOURCE_KEY}`, `${sourceIdParam.substring(0, 99)}`, {
        path: "/",
        // make accessible for all pages
        domain: getEnvVariable({ currentEnv, keyToSearch: "COOKIE_DOMAIN" }),
        expires: new Date(Date.now() + COOKIE_EXPIRATION_TIME)
        // 365 days
      });
    }
  }, [sourceid, setCookie]);
  return {
    sourceid,
    location,
    setCookie
  };
};
export {
  useSourceIdCookie as a,
  useOffersContext as u
};
//# sourceMappingURL=useSourceIdCookie-BWaK_GHK.js.map
